import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Col, Container } from "reactstrap";
import Btn from "../CommonElements/Button";
import { H3, P } from "../../AbstractElements";
import { logout } from "../../Modules/Auth/Api/Login";

const Unauthorized = () => {
  return (
    <Fragment>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="error-wrapper">
          <Container>
            <div className="svg-wrapper error4">Acceso no autorizado</div>
            <Col md="8" className="offset-md-2">
              <H3>403</H3>
              <P attrPara={{ className: "sub-content" }}>Forbiden Error</P>
              <Link onClick={logout}>
                <Btn attrBtn={{ color: "primary" }}>VOLVER AL LOGIN</Btn>
              </Link>
            </Col>
          </Container>
        </div>
      </div>
    </Fragment>
  );
};

export default Unauthorized;
